import { ISetNameParams } from '../types/actionParams';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class RenameDatasourceRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(params: ISetNameParams) {
    super('renameDatasource', params);
  }
}